import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Paper, ListItem, FontIcon } from 'material-ui';
import ProfileImage from '../../../app-bar/profile-image';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import RightSideContent from './right-side/rightSideContent';
import LoadingOverlay from '../../../tc-ui/loading-overlay';
import PartnerNode from '../../contract-activities-products/contract-policies/partner-node';
import ActionButtons from './right-side/actionButtons';
import moment from 'moment';
import queryString from 'query-string';
import R from 'ramda';

const propTypes = {
  contractRequest: PropTypes.object,
  updateProps: PropTypes.func,
  sendContracts: PropTypes.func,
  message: PropTypes.string,
  subject: PropTypes.string,
  templates: PropTypes.array,
  drafts: PropTypes.array,
  templateSelected: PropTypes.object,
  templateGroupSelected: PropTypes.object,
  contractsSent: PropTypes.bool,
  bccSelf: PropTypes.bool,
  assignTag: PropTypes.bool,
  assignFolder: PropTypes.bool,
  tags: PropTypes.array,
  folders: PropTypes.array,
  sendingContracts: PropTypes.bool,
  showReviewAndSendForResponseWizard: PropTypes.bool,
  isSingleLoc: PropTypes.bool,
  loadedTemplates: PropTypes.bool,
};

const overLapDates = contractRequest => R.anyPass([
  obj => obj.startDate <= contractRequest.endDate && obj.startDate >= contractRequest.startDate,
  obj => obj.endDate <= contractRequest.endDate && obj.endDate >= contractRequest.startDate,
  obj => obj.startDate < contractRequest.startDate && obj.endDate > contractRequest.endDate,
])

class ContractRequest extends React.Component {
  componentWillMount() {
    const {
      loadedLocations,
      locations,
      loadedTemplates,
      templates,
      getLocations: getL,
      getTemplates: getT,
    } = this.props;
    if (!(loadedLocations || locations.length)) getL();
    if (!(loadedTemplates || templates.length)) getT();
  }
  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.contractRequest && nextProps.contractRequest.startDate && nextProps.contractRequest.endDate)
      && nextProps.templates
      && nextProps.templates.length
      && R.find(overLapDates(nextProps.contractRequest), nextProps.templates || [])
    ) {
      window.location = `${
        process.env.NEW_SYSTEM_URL
      }/partner-management/send-assets?${queryString.stringify({
        partnerids: [nextProps.contractRequest.partners[0].id],
        contactids: [nextProps.contractRequest.contacts[0].id],
        go_back_to: `${window.location.protocol}//${window.location.host}/contracting/contract-list/recent`,
        open_asset_type: 'rates',
      })}&jwt=${localStorage.getItem('jwt')}`;
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const {
      contractRequest,
      loadedTemplates,
      templates,
      drafts,
    } = this.props;
    // TODO: make the contract request view more intuitive for supplier.
    // Before then, we will just route user to send assets wizard.
    const foundMatchedTemplate = R.find(overLapDates(contractRequest), templates || []);
    if (
      !(contractRequest && contractRequest.contentLoaded)
      || !(loadedTemplates || templates.length)
      || foundMatchedTemplate
    ) {
      return <LoadingOverlay loading text={`Thank you for your patience.\nWe are checking if you have available templates for this request.`}/>;
    }
    const foundMatchedDrafts = R.filter(R.allPass([
      draft => draft.originFrom !== 'edited',
      overLapDates(contractRequest)
    ]), drafts || []);
    const respondedContractLength = R.pathOr(0, ['respondedContractList', 'length'], contractRequest);
    const divStyleSwitch = { backgroundColor: '#eeeeee', width: '30%', padding: '2%', paddingBottom: '48px', minHeight: '500px' };
    return (
      <Paper style={{ width: '100%', margin: 'auto auto 64px auto', display: 'flex', flexDirection: 'column' }}>
        <div style={{ backgroundColor: '#00bcd4', color: '#fff', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between' }}>
          <h4 style={{ width: '50%', color: '#FFFFFF', fontWeight: '500', paddingRight: '32px', textAlign: 'right' }}>Contract Request</h4>
          <FlatButton
            icon={<FontIcon className="tc-icon-arrow_back" color="white" />}
            label="back"
            labelPosition="after"
            style={{ color: 'white' }}
            onTouchTap={() => this.context.router.goBack()}
          />
        </div>
        <div style={{ display: 'flex' }}>
          <div style={divStyleSwitch}>
            <ListItem
              disabled
              leftAvatar={
                <ProfileImage
                  className="profile-link-image connections-profile-link-image"
                  companySlugName={R.path(['from', 'name'], contractRequest)}
                  imageUrl={R.path(['from', 'avatar'], contractRequest)}
                  style={{ marginLeft: '-3%' }}
                />
              }
              style={{ paddingBottom: '12%', fontWeight: '500' }}
              primaryText={R.path(['from', 'name'], contractRequest)}
              secondaryText={R.path(['from', 'email'], contractRequest)}
            />
            <PartnerNode
              partners={contractRequest.partners}
              contacts={contractRequest.contacts}
            />
            <hr style={{ marginTop: '1%' }} />
            <b>This request was prepared for:</b><br/>
            {(contractRequest.to || {}).name}
            <hr style={{ marginTop: '18px' }} />
            <div style={{ padding: '2%', minHeight: '150px' }}>
              <div>
                <p style={{ fontWeight: 'bold', color: '#757575' }}>Contracting Period</p>
                <p style={{ color: '#616161' }}>
                  {moment.utc((contractRequest || {}).startDate).format('DD MMM YYYY')}-{moment.utc((contractRequest || {}).endDate).format('DD MMM YYYY')}
                </p>
              </div>
              <div>
                <p style={{ fontWeight: 'bold', color: '#757575' }}>Submission Criteria</p>
                {R.pathOr('', ['buyerInfo', 'submissionCriteria'], contractRequest) ?
                  <p style={{ color: '#616161', maxHeight: '300px', overflowY: 'scroll' }}>{R.pathOr('', ['buyerInfo', 'submissionCriteria'], contractRequest)}</p> :
                  <p style={{ color: '#616161' }}>N/A</p>
                }
              </div>
              <div>
                <p style={{ fontWeight: 'bold', color: '#757575' }}>Terms & Conditions</p>
                {R.pathOr('', ['buyerInfo', 'termsAndConditions'], contractRequest) ?
                  <p style={{ color: '#616161', maxHeight: '300px', overflowY: 'scroll' }}>{R.pathOr('', ['buyerInfo', 'termsAndConditions'], contractRequest)}</p> :
                  <p style={{ color: '#616161' }}>N/A</p>
                }
              </div>
            </div>
          </div>
          <div style={{ width: '70%', display: 'inline-block', height: '100%' }}>
            <div style={{ color: '#616161', fontSize: '14px', padding: '16px 32px' }}>
              <b>No templates found for {moment.utc((contractRequest || {}).startDate).format('DD MMM YYYY')}-{moment.utc((contractRequest || {}).endDate).format('DD MMM YYYY')}.  Please create a new template below.</b>
              <div style={{ marginTop: '16px', fontSize: '12px' }}>
                NOTE: You can import rates from an existing template on the next step.
              </div>
            </div>
            <RightSideContent
              {...this.props}
              router={this.context.router}
              foundMatchedTemplate={foundMatchedTemplate}
              foundMatchedDrafts={foundMatchedDrafts}
            />
            {
              Boolean(foundMatchedTemplate) && (
                <ActionButtons
                  {...this.props}
                  router={this.context.router}
                />
              )
            }
          </div>
        </div>
      </Paper>
    );
  }
}
const mapStateToProps = ({ contracting, user }) => {
  return ({
    ...contracting.supplierWizard.toJS(),
    drafts: contracting.templateList.get('drafts').toJS(),
    isSingleLoc: user.get('allLocations').length < 2,
  });
};

ContractRequest.propTypes = propTypes;
ContractRequest.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(ContractRequest);



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/respond-contract-request/container.jsx